export default "__VITE_ASSET__DKhZNwQ9__"